// App.js
import { Routes, Route } from "react-router-dom";
import NavBar from "./Components/NavBar";
import UnitCsdCalculator from "./Surveys/unit-csd-calculator";
import CsdCalculator from "./Surveys/csd-calculator";
import CrossLeaseCalculator from "./Surveys/cross-lease-csd-calculator";
import PrintableArea from "./Surveys/PrintableArea";
import './index.css';
import './fonts';

function defaultCalculator(path) {
  return <Route
    path={ path }
    element={<CsdCalculator config={{ useNewFees: true }}/>}
  />;
}

const App = () => {
  return (
    <>
      <NavBar />
      <PrintableArea title="Print me!">
        <Routes>
          { defaultCalculator("/") }
          { defaultCalculator("/csd-calculator") }
          <Route
            path="/cross-lease-csd-calculator"
            element={<CrossLeaseCalculator config={{ useNewFees: true }}/>}
          />
          <Route
            path="/unit-csd-calculator"
            element={<UnitCsdCalculator config={{ useNewFees: true }}/>}
          />
        </Routes>
      </PrintableArea>
    </>
  );
};

export default App;
